/**
 * DSS Smart Filters Adapter
 * 
 * Bridges DSS filter forms with the existing component-facets.js AJAX system.
 * The existing FacetFiltersForm expects specific form IDs (FacetFiltersForm, etc.).
 * This adapter intercepts DSS form changes and routes them through the existing system.
 */
(function () {
  'use strict';

  const DSS_FORM_IDS = ['DssFilterFormSidebar', 'DssFilterFormTopbar', 'DssFilterFormMobile'];
  const GRID_SELECTOR = '#main-collection-product-grid';

  function init() {
    DSS_FORM_IDS.forEach(formId => {
      const form = document.getElementById(formId);
      if (!form || form._dssInit) return;
      form._dssInit = true;

      // Listen for input changes (checkboxes, selects)
      form.addEventListener('input', debounce(() => {
        submitViaFacets(form);
      }, 500));

      // Listen for select changes specifically
      form.addEventListener('change', (e) => {
        if (e.target.tagName === 'SELECT') {
          submitViaFacets(form);
        }
      });
    });
  }

  function submitViaFacets(dssForm) {
    // Find the original FacetFiltersForm element
    const originalForm = document.querySelector('facet-filters-form form');
    if (!originalForm) return;

    // Copy DSS form data into the original form's hidden inputs
    // Then trigger the original system's submit
    const formData = new FormData(dssForm);
    const params = new URLSearchParams(formData).toString();

    // Use the existing FacetFiltersForm.renderPage if available
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
      FacetFiltersForm.renderPage(params, null, true);
    }
  }

  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on section reload
  document.addEventListener('shopify:section:load', init);
})();
